import { TContentHubButton, StringField } from '../../../types/types';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { TContentHubSeriesOverviewProps } from '../types/productSeriesOverview.types';

export class OverviewTextModel {
  private readonly fields?;
  private readonly params?: ComponentParamsGeneral;

  constructor(props: TContentHubSeriesOverviewProps) {
    this.fields = props?.fields || null;
    this.params = props?.params;
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get description(): StringField {
    return {
      value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description),
    };
  }

  get primaryLink(): TContentHubButton {
    return this.fields?.apiData?.button1;
  }

  get primaryLinkUrl(): string | undefined {
    return appendRootToInternalLink(this.primaryLink.url);
  }

  get secondaryLink(): TContentHubButton {
    return this.fields?.apiData?.button2;
  }

  get secondaryLinkUrl(): string | undefined {
    return appendRootToInternalLink(this.secondaryLink.url);
  }

  get enableBuildPriceCTA(): boolean | undefined {
    return this.params?.enableBuildPriceCTA === '1';
  }
}
